import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { instanceToPlain } from 'class-transformer';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpOperation } from '../../enums/http-operation';
import { GeneratedPdfModel } from '../../models/pdf/generated-pdf.model';
import { EndpointService } from '../../services/endpoints/endpoint.service';
import { HttpErrorService } from '../../services/http-error.service';
import * as fromPdfActions from './generate-pdf.actions';

@Injectable()
export class PdfEffects {
  generatePdf$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromPdfActions.generatePdf),
      map((action) => action.payload),
      switchMap((printPath) => {
        const endpoint = this.endpointService.getGeneratedPdfSlug(HttpOperation.Post);
        const pdfPostModel = instanceToPlain(printPath);

        return this.http.post<unknown>(endpoint, pdfPostModel).pipe(
          map((generatedFile: GeneratedPdfModel) => {
            return fromPdfActions.pdfGenerated({ payload: generatedFile });
          }),
          catchError((error) => {
            return this.httpErrorService.handleError(
              'Pdf',
              fromPdfActions.pdfGenerated,
              fromPdfActions,
              error,
            );
          }),
        );
      }),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly endpointService: EndpointService,
    private readonly httpErrorService: HttpErrorService,
  ) {}
}
